const About = () => {
  const aboutList = [
    {
      img: "/images/about1.webp",
      txt1: `대한민국 전지역 어디라도!`,
      txt2: "국내 전지역 해결가능",
    },
    {
      img: "/images/about2.webp",
      txt1: `카이노스 Bio 케미칼`,
      txt2: "회사 현황 및 구성",
    },
    {
      img: "/images/about3.webp",
      txt1: `카이노스 Bio 케미칼`,
      txt2: "회사연혁 및 업력",
    },
  ];

  return (
    <div
      id="about"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36"
    >
      <div
        id="title"
        className="relative w-full h-fit text-center mb-10 xl:mb-14"
      >
        <h3 className="font-normal">회사소개</h3>
        <p className="text-primary my-5 lg:text-lg">- About Us -</p>
        <p className=" lg:text-lg">
          사람과&nbsp;환경을&nbsp;함께&nbsp;생각하는&nbsp;기업
          카이노스&nbsp;Bio&nbsp;케미칼
        </p>
      </div>
      <div className="relative w-full h-fit max-w-[1300px] mx-auto grid grid-cols-1 lg:grid-cols-3 gap-5 lg:gap-6">
        {aboutList.map((v, i) => (
          <div
            key={i}
            data-aos="fade-up"
            className="relative w-full h-full border border-primary btn6 inline-block"
          >
            <div className="relative w-full h-72 xl:h-80 overflow-hidden">
              <img
                className="!relative w-full h-full object-cover object-center transition-transform duration-300"
                alt={`카이노스 바이오케미칼 회사소개 ${v.txt2}`}
                src={v.img}
                width={414}
                height={506}
              />
            </div>
            <div className=" relative w-full h-fit my-3 text-center">
              <p
                className="mt-3 xl:text-xl"
                dangerouslySetInnerHTML={{ __html: v.txt1 }}
              ></p>
              <p className="text-primary text-lg xl:text-2xl 2xl:text-3xl">
                {v.txt2}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default About;
